<template>
    <div style="padding-top: 24px">
        <v-select v-model="form.countryId" :items="countries" item-text="nameRu" item-value="id"
                  :label="$t('country')" :rules="required ? reqField : []" outlined dense/>
        <div v-if="form.countryId === 4948">
            <v-select v-model="form.regionId" :items="regions" item-text="nameRu" item-value="id"
                      :label="$t('region')" :rules="required ? reqField : []" outlined dense/>
            <div v-if="!onlyRegion">
                <v-select v-model="form.districtId" :items="helper.districts" item-text="nameRu" item-value="id"
                          :label="$t('district')" outlined dense/>
                <v-select v-model="form.aymakId" :items="helper.aymaks" item-text="nameRu" item-value="id"
                          label="Аймак" outlined dense/>
                <v-select v-model="form.villageId" :items="helper.villages" item-text="nameRu" item-value="id"
                          label="Село" outlined dense/>

                <div v-if="!onlyVillage">
                    <v-select v-model="form.streetId" :items="helper.streets" item-text="nameRu" item-value="id"
                              :label="$t('street')" outlined dense/>
                </div>
                <div v-if="typeof houseTxt !== 'undefined'" class="form__group">
                    <label class="form__label  form__label--block">Дом</label>
                    <input v-model="form.houseTxt" type="text" class="field field--full-width"/>
                </div>
            </div>
        </div>
        <div v-else>
            <v-textarea outlined dense
                label="Нас. пункт"
            />
        </div>
    </div>
</template>

<script>

import { AddressRegistryService } from '../../_services/address-registry.service'

const addressService = new AddressRegistryService()

export default {
  name: 'AddressSelectDetailed',

  props: {
    countryId: [Number, String],
    regionId: [Number, String],
    districtId: [Number, String],
    aymakId: [Number, String],
    villageId: [Number, String],
    streetId: [Number, String],
    houseTxt: String,
    onlyRegion: Boolean,
    onlyVillage: Boolean,
    required: Boolean
  },

  computed: {
    regions () {
      return this.$store.state.address.regions
    },
    countries () {
      return this.$store.state.address.countries
    }
  },

  data () {
    return {
      form: {
        countryId: this.countryId || '',
        regionId: this.regionId || '',
        districtId: this.districtId || '',
        aymakId: this.aymakId || '',
        villageId: this.villageId || '',
        streetId: this.streetId || '',
        houseTxt: this.houseTxt || ''
      },
      helper: {
        districts: [],
        aymaks: [],
        villages: [],
        streets: []
      },
      reqField: [v => !!v || 'Обязательное поле']
    }
  },

  watch: {
    'form.countryId' (countryId) {
      if (countryId === 4948) { this.$store.dispatch('address/fetchRegions') }

      this.helper.districts = []
      this.helper.villages = []
      this.helper.aymaks = []
      this.helper.streets = []
      this.form.districtId = ''
      this.form.aymakId = ''
      this.form.villageId = ''
      this.form.regionId = ''
      this.$emit('update:countryId', countryId)
    },
    'form.regionId' (regionId) {
      this.helper.districts = []
      if (regionId && !this.onlyRegion) {
        this.fetchChild(regionId).then(() => {
          this.fetchStreets()
        })
      }
      this.helper.villages = []
      this.helper.aymaks = []
      this.helper.streets = []
      this.form.districtId = ''
      this.form.aymakId = ''
      this.form.villageId = ''
      this.$emit('update:regionId', regionId)
    },
    'form.districtId' (districtId) {
      this.helper.aymaks = []
      if (districtId) {
        this.fetchChild(districtId).then(() => {
          this.fetchStreets()
        })
      }
      this.helper.villages = []
      this.form.aymakId = ''
      this.form.villageId = ''
      this.$emit('update:districtId', districtId)
    },
    'form.aymakId' (aymakId) {
      this.helper.villages = []
      if (aymakId) {
        this.fetchChild(aymakId).then(() => {
          this.fetchStreets()
        })
      }
      this.form.villageId = ''
      this.$emit('update:aymakId', aymakId)
    },
    'form.villageId' (villageId) {
      if (villageId) {
        this.fetchStreets()
      }
      this.$emit('update:villageId', villageId)
    },
    'form.streetId' (streetId) {
      this.$emit('update:streetId', streetId)
    },
    'form.houseTxt' (houseTxt) {
      this.$emit('update:houseTxt', houseTxt)
    },
    houseTxt (txt) {
      this.form.houseTxt = txt
    },
    regionId (id) {
      this.form.regionId = id
    },
    districtId (id) {
      this.form.districtId = id
    },
    aymakId (id) {
      this.form.aymakId = id
    },
    villageId (id) {
      this.form.villageId = id
    },
    streetId (id) {
      this.form.streetId = id
    }
  },

  methods: {
    fetchChild (id, result) {
      return addressService.getChildren(id)
        .then(data => {
          if (result) {
            if (result === 'regions') this.helper.regions = data
            else if (result === 'districts') this.helper.districts = data
            else if (result === 'aymaks') {
              this.helper.aymaks = data
              this.fetchStreets()
            } else if (result === 'villages') {
              this.helper.villages = typeof data.id === 'undefined' ? data : [data]
            }
          } else {
            if (data.length > 0) {
              switch (data[0].type) {
                case 5:
                case 2:
                  this.helper.regions = data
                  break
                case 3:
                case 6:
                  this.helper.districts = data
                  break
                case 4:
                case 7:
                case 101:
                  this.helper.aymaks = data
                  break
                default:
                  this.helper.villages = data
                  break
              }
            }
          }
        })
    },

    fetchStreets () {
      if (!this.onlyVillage) {
        return addressService.getStreets(this.form.villageId || this.form.aymakId || this.form.districtId || this.form.regionId)
          .then(data => {
            this.helper.streets = typeof data.id === 'undefined' ? data : [data]
          })
      }
    }
  },

  mounted () {
    this.$store.dispatch('address/fetchCountries')
    if (this.regionId) { this.fetchChild(this.regionId) }
    if (this.districtId) { this.fetchChild(this.districtId) }
    if (this.aymakId) { this.fetchChild(this.aymakId) }
    if (this.streetId) { this.fetchStreets() }
  }
}
</script>

<style scoped>

</style>
